import React, { useLayoutEffect, useState } from "react";

export const LayoutContext = React.createContext<{
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  title: "",
  setTitle: () => {},
  loading: false,
  setLoading: () => {},
});

interface LayoutProviderProps {
  children: React.ReactNode;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const [title, setTitle] = useState<string>("Test title");
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    document.title = `${title} | Whappo Dashboard`;
  }, [title]);

  return (
    <LayoutContext.Provider
      value={{
        title,
        setTitle,
        loading,
        setLoading,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
